import { store } from 'src/store';
import { selectAuthToken } from 'src/store/selectors';

const getResponse = async (response: Response) => {
  const contentType = response.headers.get('content-type');

  if (contentType?.includes('application/json')) {
    return await response.json();
  } else if (contentType?.includes('text/html')) {
    return await response.text();
  } else if (contentType?.includes('text/xml')) {
    const textResponse = await response.text();
    return JSON.parse(textResponse);
  } else {
    return response;
  }
};

interface RequestOptions {
  headers?: Record<string, string>;
}

export type HttpMethod = 'GET' | 'POST' | 'PUT' | 'PATCH' | 'DELETE';

export async function request(
  url: string,
  method: HttpMethod,
  body?: any,
  options?: RequestOptions,
): Promise<any> {
  const idToken = selectAuthToken(store.getState());

  const headers = {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${idToken}`,
    ...(options?.headers || {}),
  };

  const response = await fetch(url, {
    method,
    headers,
    ...(body ? { body: JSON.stringify(body) } : {}),
  });

  if (!response.ok) {
    const data = await getResponse(response);
    throw new Error(data?.error?.message || 'Failed to perform request');
  }

  const resolved = await getResponse(response);
  return resolved;
}

export const get = async (url: string, options?: RequestOptions) =>
  await request(url, 'GET', undefined, options);

export const post = async (url: string, body: any, options?: RequestOptions) =>
  await request(url, 'POST', body, options);

export const put = async (url: string, body: any, options?: RequestOptions) =>
  await request(url, 'PUT', body, options);

export const patch = async (url: string, body: any, options?: RequestOptions) =>
  await request(url, 'PATCH', body, options);
